import React from "react";
import "../styles/analytics.css";

function Analytics() {
  return (
    <div className="analytics">
      <h2>Analytics</h2>
      Track your session & engagement stats.
    </div>
  );
}

export default Analytics;
